export default function getHeaderHeight() {
  const mobileBreakpoint = 800;
  return (window.matchMedia(`(max-width: ${mobileBreakpoint}px)`).matches) ? 56 : 80;
}
